import { useApi } from '@mainstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { identityApiRef } from '@mainstage/core-plugin-api';
import { systemPrototypeApiRef } from '@agilelab/plugin-wb-system-prototype-common';

export const useSystemPrototype = (id: number) => {
  const identityApi = useApi(identityApiRef);
  const systemPrototypeApi = useApi(systemPrototypeApiRef);

  return useQuery({
    queryKey: ['system-prototype', id],
    queryFn: async () => {
      const credentials = await identityApi.getCredentials();
      if (!credentials.token) {
        throw new Error('No token available');
      }
      const typedCredentials = { token: credentials.token };

      return systemPrototypeApi.getSystemPrototype(id, typedCredentials);
    },
  });
};
